export const permissionNames = {
  CLAIMS: "ClaimsAccess",
  PAYROLL: "PayrollReports",
  CERTS: "Certificates",
};

export const permissionLabels = {
  CLAIMS: { section: "RequestAccess", key: "PermissionView" },
  PAYROLL: { section: "RequestAccess", key: "PermissionPay" },
  CERTS: { section: "RequestAccess", key: "PermissionCerts" },
};
